// src/store/index.js
import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

export default createStore({
    state: {
        hasDrawn: false,
        prize: null
    },
    mutations: {
        setPrize(state, prize) {
            state.prize = prize
            state.hasDrawn = true
        },
        reset(state) {
            state.hasDrawn = false
            state.prize = null
        }
    },
    plugins: [createPersistedState({
        key: 'lottery',           // localStorage key
        storage: window.localStorage
    })]
})
